<script setup lang="ts">
import { usePatient } from "@/composables/models/patient/usePatient";
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import { computed } from "vue";
import { useRoute } from "vue-router";
import NextAddEdit from "@/components/models/patient/forms/visitInstructions/NextAddEdit.vue";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.nextVisitInstruction" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PATIENT__NEXTVISITINSTRUCTIONSV2);
    },
  },
});

const route = useRoute();
const patientId = computed(() => (route.params as { id: string }).id);

const { data: patient, isLoading: isPatientLoading } = usePatient({ id: patientId });
</script>

<template>
  <v-skeleton-loader :loading="isPatientLoading">
    <next-add-edit
      :patient="patient"
      creating
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
